<template>
  <div>
    <label class="d-block">
      {{ $t(config.label) }}
    </label>
    <validation-provider
      :name="$t(config.name)"
      :rules="config.rules"
      v-slot="{ errors }"
    >
      <v-select
        :options="doOptions"
        v-model="model"
        :clearable="false"
        :reduce="(val) => val.value"
        input-id="do_select"
        @input="$emit('input', model)"
      />
      <p v-if="config.hint" class="mb-0 small">{{ $t(config.hint) }}</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    multiple: Boolean | Number,
    config: Object,
    context: Object,
  },
  data() {
    return {
      model: null,
    };
  },
  created() {
    this.model = this.value;
  },
  computed: {
    doOptions() {
      return [
        {
          label: "Salida 1",
          value: 1,
        },
        {
          label: "Salida 2",
          value: 2,
        },
        {
          label: "Salida 3",
          value: 3,
        },
      ];
    },
  },
};
</script>

<style></style>
